import styled from 'styled-components';

export const StyledMyTeam = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  position: relative;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--white);

  .head {
    margin: 0 0 20px;

    @media (min-width: 576px) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
    }

    .search {
      width: 280px;
    }

    .domain-name-holder {
      display: flex;
      gap: 10px;
      color: #313131;

      .heading {
        display: block;
        font-size: 20px;
        line-height: 24px;
      }
    }

    .form-wrap {
      display: flex;
      align-items: baseline;
      gap: 10px;

      @media (max-width: 575px) {
        margin-bottom: 20px;
      }

      span {
        color: #313131;
      }
    }

    .filter-wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 15px;
      width: 100%;
      margin-bottom: 15px;

      @media (min-width: 430px) {
        flex-direction: row;
      }
      @media (min-width: 576px) {
        justify-content: flex-end;
        margin-bottom: 0;
      }
      .selectwrap {
        width: 100%;
        @media (min-width: 576px) {
          max-width: 200px;
        }
      }
      .inner-filter {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
      }
    }
  }

  .action-list {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }

  .name-holder {
    display: flex;
    align-items: center;
    gap: 8px;

    .user-img {
      width: 35px;
      border-radius: 50%;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }

    .user-name {
      display: block;
      font-weight: 700;
    }
  }
`;

export const StyledAddNewMember = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--white);
  position: relative;

  .content-holder {
    width: 100%;
    max-width: 650px;

    .head {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      text-align: center;
      margin: 0 0 30px;

      .heading {
        display: block;
        font-size: 25px;
        line-height: 30px;
        font-weight: 700;
        color: var(--text-color-50);
        text-align: center;
        margin: 0 0 10px;
      }

      .text {
        display: block;
      }
    }

    .title {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-style: italic;
      color: var(--text-color-50);
      margin: 0 0 16px;
    }

    .input-wrap {
      display: flex;
      gap: 20px;

      &.last-wrapper {
        margin: 0 0 30px;
      }
    }

    .btn-holder {
      display: flex;
      justify-content: center;
    }
  }
`;
